import type { StoredSimulation } from './parseStoredSimulation';

const STORAGE_KEYS = {
  open: 'popstore-dev-panel:open',
  dismissed: 'popstore-dev-panel:dismissed',
  profileId: 'popstore-dev-panel:browser-chrome:profile',
  toolbarState: 'popstore-dev-panel:browser-chrome:toolbar',
  navigationId: 'popstore-dev-panel:browser-chrome:navigation',
} as const;

const OPEN_VALUE = 'true';
const DISMISSED_VALUE = 'true';

type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

function readKey(key: StorageKey): string | null {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.error(`[dev-panel] could not read ${key}:`, error);
    return null;
  }
}

function writeKey(key: StorageKey, value: string | null): void {
  try {
    if (value == null) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, value);
    }
  } catch (error) {
    console.error(`[dev-panel] could not write ${key}:`, error);
  }
}

export function readPanelOpen(): boolean {
  return readKey(STORAGE_KEYS.open) === OPEN_VALUE;
}

export function writePanelOpen(open: boolean): void {
  writeKey(STORAGE_KEYS.open, open ? OPEN_VALUE : null);
}

export function readPanelDismissed(): boolean {
  return readKey(STORAGE_KEYS.dismissed) === DISMISSED_VALUE;
}

export function writePanelDismissed(): void {
  writeKey(STORAGE_KEYS.dismissed, DISMISSED_VALUE);
}

export function readStoredSimulation(): StoredSimulation {
  return {
    profileId: readKey(STORAGE_KEYS.profileId),
    toolbarState: readKey(STORAGE_KEYS.toolbarState),
    navigationId: readKey(STORAGE_KEYS.navigationId),
  };
}

export function writeStoredSimulation(stored: StoredSimulation): void {
  writeKey(STORAGE_KEYS.profileId, stored.profileId);
  writeKey(STORAGE_KEYS.toolbarState, stored.toolbarState);
  writeKey(STORAGE_KEYS.navigationId, stored.navigationId);
}
